<script setup>
import { defineProps } from 'vue';

defineProps({
  loading: Boolean
});
</script>

<template>
  <div v-if="loading" class="loading-screen">
    <div class="loading-container">
      <div class="logo-container">
        <img src="../assets/Yalaagames.png" alt="Loading Logo" class="logo-image" style="width: 150px; height: 150px;">
      </div>
      <div class="loading-text">Loading...</div>
    </div>
  </div>
</template>

<style scoped>
.loading-screen {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #121212;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}

.loading-container {
  text-align: center;
}

.logo-container {
  width: 64px;
  height: 64px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto;
  animation: pulse 1.5s ease-in-out infinite;
}

.logo-image {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.loading-text {
  margin-top: 1rem;
  color: #e5e7eb;
  font-size: 1rem;
  font-weight: 500;
  opacity: 0.8;
}

@keyframes pulse {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.1);
  }
  100% {
    transform: scale(1);
  }
}
</style>